/**
 * SenderPicker (2026-10-03, DS: "one place for senders"): the From identity for campaigns, automations and journeys
 * comes from Email → Senders (GET /v1/campaign/email/senders, domain-verified identities). Picking one fills
 * fromName/fromEmail on the owning editor; the free-text override stays available under "Custom".
 */
import React from "react";
import { Link } from "react-router-dom";
import { api, idStr } from "./api";
export default class SenderPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      senders: null,
      error: null,
      custom: false
    };
  }
  componentDidMount() {
    this._alive = true;
    api("GET", "/senders").then(d => {
      if (!this._alive) return;
      const senders = d && (d.items || d) || [];
      const list = Array.isArray(senders) ? senders : [];
      const match = list.find(s => (s.fromEmail || "").toLowerCase() === (this.props.fromEmail || "").toLowerCase());
      // no identity yet, or the editor already carries an address that is not an identity → custom mode
      this.setState({
        senders: list,
        custom: !!this.props.fromEmail && !match
      });
      if (!this.props.fromEmail && list.length && this.props.onPick) {
        const def = list.find(s => s.isDefault) || list[0];
        this.props.onPick({
          fromName: def.fromName || "",
          fromEmail: def.fromEmail || "",
          senderId: idStr(def.id)
        });
      }
    }).catch(e => {
      if (this._alive) this.setState({
        senders: [],
        error: e && e.message
      });
    });
  }
  componentWillUnmount() {
    this._alive = false;
  }
  render() {
    const {
      fromName,
      fromEmail,
      onPick,
      inputStyle,
      labelStyle
    } = this.props;
    const {
      senders,
      custom
    } = this.state;
    const current = (senders || []).find(s => (s.fromEmail || "").toLowerCase() === (fromEmail || "").toLowerCase());
    const sel = {
      ...(inputStyle || {}),
      height: 32
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "ec-sender-picker"
    }, /*#__PURE__*/React.createElement("label", {
      style: labelStyle
    }, "Sender identity"), /*#__PURE__*/React.createElement("div", {
      className: "row nowrap",
      style: {
        gap: 8,
        alignItems: "center",
        flexWrap: "wrap"
      }
    }, /*#__PURE__*/React.createElement("select", {
      style: {
        ...sel,
        minWidth: 320
      },
      value: custom ? "__custom" : current ? current.fromEmail : "",
      onChange: e => {
        if (e.target.value === "__custom") {
          this.setState({
            custom: true
          });
          return;
        }
        const s = (senders || []).find(x => x.fromEmail === e.target.value);
        this.setState({
          custom: false
        });
        if (s && onPick) onPick({
          fromName: s.fromName || "",
          fromEmail: s.fromEmail || "",
          senderId: idStr(s.id)
        });
      }
    }, senders == null ? /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "loading\u2026") : null, senders && !senders.length ? /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "no sender identities yet") : null, (senders || []).map(s => /*#__PURE__*/React.createElement("option", {
      key: s.fromEmail,
      value: s.fromEmail
    }, s.fromName ? `${s.fromName} <${s.fromEmail}>` : s.fromEmail, s.domainAuthStatus === "verified" ? " · verified" : s.domainAuthStatus ? ` · ${s.domainAuthStatus}` : "", s.isDefault ? " · default" : "")), /*#__PURE__*/React.createElement("option", {
      value: "__custom"
    }, "Advanced: custom From name and email\u2026")), /*#__PURE__*/React.createElement(Link, {
      to: "/Email/settings",
      className: "dim",
      style: {
        fontSize: 12
      }
    }, "Manage senders")), custom ? /*#__PURE__*/React.createElement("div", {
      className: "row nowrap",
      style: {
        gap: 12,
        marginTop: 8,
        flexWrap: "wrap"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: "1 1 220px"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: labelStyle
    }, "From name"), /*#__PURE__*/React.createElement("input", {
      style: inputStyle,
      value: fromName || "",
      onChange: e => onPick && onPick({
        fromName: e.target.value,
        fromEmail: fromEmail || "",
        senderId: null
      })
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: "1 1 220px"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: labelStyle
    }, "From email"), /*#__PURE__*/React.createElement("input", {
      style: inputStyle,
      value: fromEmail || "",
      onChange: e => onPick && onPick({
        fromName: fromName || "",
        fromEmail: e.target.value,
        senderId: null
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: "mini",
      style: {
        flex: "1 1 100%"
      }
    }, "A custom address outside a verified domain is rewritten to the verified From at send time, with your address as Reply-To.")) : null);
  }
}